// extracted by mini-css-extract-plugin
module.exports = {"container":"profile_container__3KIFf","card":"profile_card__1dEAH","avatar":"profile_avatar__qredl"};